import { render } from "./EmployeeContract.vue?vue&type=template&id=1472e636&scoped=true"
import script from "./EmployeeContract.vue?vue&type=script&lang=js"
export * from "./EmployeeContract.vue?vue&type=script&lang=js"

import "./EmployeeContract.vue?vue&type=style&index=0&id=1472e636&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1472e636"]])

export default __exports__